/**
 * BFAnimationQueue
 * Creates waypoints and a queue of any '.animated' item within a given scope;
 * @scope - The scope is a parent element which the queue is limited to
 */
( function ( $ ) {

    /**
     * The main JS Object
     * @param el
     * @returns {$.AnimationQueue}
     * @constructor
     */
    $.AnimationQueue = function( el ) {

        this.scope = ( el instanceof $ ) ? el : $( el ); // This is our scope -- Row, Widget, Etc that this queue manages
        this.waypoints = []; // Holds each waypoint object so we can clean up after ourselves
        this.waypoints_offset = '85%'; // threshold to trigger waypoints
        this.queue = []; // Work that is ready to do - the queue itself
        this.delay = 0; // Default delay to be used for sequential option ( defaults as 0 )
        this.items = []; // Default items
        this.order = 'asc'; // Default ordering for items

        // Set everything up :: This is the base initialization of the object
        this.setup();

        // Need to return the plugin function so we can chain jQuery functions if needed
        return this;
    };

    /**
     * Set up the queue, and register waypoints
     */
    $.AnimationQueue.prototype.setup = function() {
        var self = this;

        // If our scope is tagged with sequential animations, set our default delay
        if( self.scope.hasClass('sequential-vertical' ) ) {
            self.sequential_type = 'vertical';
            self.delay = 350;
        } else if ( self.scope.hasClass('sequential-column' ) ) {
            self.sequential_type = 'column';
            self.delay = 350;
        } else {
            self.sequential_type = 'none';
            self.delay = 0;
        }

        if ( self.scope.hasClass('animate-desc' ) ) {
            self.order = 'desc';
        }

        self.buildItems();
        self.registerWaypoint();

    };

    /**
     * Finds all animated items within our scope, and attaches them to self.items along with their offset value
     */
    $.AnimationQueue.prototype.buildItems = function() {
        var self = this;
        var rtn_items = [];

        self.scope.find('.animated').each( function( i, el ) {
            el = ( el instanceof $ ) ? el : $( el );
            var offset = el.offset().top;
            rtn_items.push( { 'element': el, 'offset': offset } );
        } );

        self.items = rtn_items;

    };

    /**
     * Registers a Waypoint to a single element
     */
    $.AnimationQueue.prototype.registerWaypoint = function() {
        var self = this;
        var waypoint_id = self.scope.attr('id');

        // Create a waypoints object and callback handler for the element
        // and store it in our waypoints property for later reference
        self.waypoints[waypoint_id] = new Waypoint({
            element: self.scope,
            handler: function() {
                self.execWaypoint();
            },
            offset: self.waypoints_offset
        });

    };

    /**
     * Executes when a waypoint for a given element is hit
     */
    $.AnimationQueue.prototype.execWaypoint = function() {
        var self = this; // Give access to the parent inside functions
        var waypoint_id = self.scope.attr('id');

        // If using vertical sequencing, we need to reorder our 'self.items' based on offset().top
        if( 'vertical' === self.sequential_type ) {
            self.items.sort( function( a, b ) {
                return a.offset - b.offset;
            } );
        }

        $.each( self.items, function( i, data ) {
            self.addToQueue( data.element );
        });

        // If the queue isn't already running, start it
        self.playQueue();

        // We don't need this waypoint anymore - clean up
        self.waypoints[waypoint_id].destroy();
    };

    /**
     * Adds an element to the queue
     * @param el
     */
    $.AnimationQueue.prototype.addToQueue = function( el ) {
        var self = this; // Give access to the parent inside functions
        el = ( el instanceof $ ) ? el : $( el );
        // Add our item to the queue as ready to animate

        if ( 'desc' === self.order ) {
            self.queue.unshift( el );
        } else {
            self.queue.push( el );
        }
    };

    /**
     * Iterative Function: Plays the current queue through
     * @returns {boolean}
     */
    $.AnimationQueue.prototype.playQueue = function() {
        var self = this; // Give access to the parent inside functions

        // Get the next item in the queue, and remove it from the queue
        var nextInQueue = self.queue.shift();
        // Trigger our animation
        var animation_type = nextInQueue.attr('data-animation');
        nextInQueue.css( 'visibility', 'visible').addClass( animation_type );

        // Complete Animations
        self.cleanup( nextInQueue, animation_type );

        // After our set delay time, check for the next item in the queue
        setTimeout( function() {

            if (self.queue.length !== 0) {
                return self.playQueue(); // Iterate if items are left in the queue
            } else {
                return true;
            }

        }, self.delay );
    };

    /**
     * Cleans up animation classes so we don't conflict with any other @keyframe based animations (eg - hover)
     * @param el
     * @param animation_type
     */
    $.AnimationQueue.prototype.cleanup = function( el, animation_type ) {

        setTimeout( function() {
            el.removeClass( 'animated' );
            el.removeClass( animation_type );
        }, 1000 );

    };

    /**
     * Main Plugin Function
     * @returns {*}
     * @constructor
     */
    $.fn.AnimationQueue = function() {

        // Return each instance to allow for chaining of jQuery functions if needed
        return this.each( function( i, el ) {

            // Only create a new AnimationQueue instance if we have '.animated' elements within
            if( $(el).find('.animated').length !== 0 ) {
                new $.AnimationQueue(el);
            }

        });
    };

} )( jQuery );